
import { Users, Star, TrendingUp, Percent } from "lucide-react";
import { cn } from "@/lib/utils";

interface LenderMetricsProps {
  totalLoansFunded: number | null;
  rating?: string;
  successRate?: number;
  interestRate?: string;
  view?: "grid" | "list";
}

export const LenderMetrics = ({ 
  totalLoansFunded, 
  rating, 
  successRate, 
  interestRate,
  view = "grid" 
}: LenderMetricsProps) => {
  return (
    <div className={cn(
      "grid gap-4",
      view === "grid" ? "grid-cols-2" : "grid-cols-2 md:grid-cols-4"
    )}>
      <div className="flex flex-col gap-1 p-3 rounded-lg bg-primary/5">
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <Users className="h-4 w-4" />
          Loans Funded
        </span>
        <span className="text-lg font-semibold">{totalLoansFunded || 0}</span>
      </div>
      
      <div className="flex flex-col gap-1 p-3 rounded-lg bg-yellow-500/5">
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <Star className="h-4 w-4 text-yellow-500" />
          Rating
        </span>
        <span className="text-lg font-semibold">{rating || '4.5'}/5</span>
      </div>

      <div className="flex flex-col gap-1 p-3 rounded-lg bg-green-500/5">
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <TrendingUp className="h-4 w-4 text-green-500" />
          Success Rate
        </span>
        <span className="text-lg font-semibold">{successRate || 98}%</span>
      </div>

      <div className="flex flex-col gap-1 p-3 rounded-lg bg-secondary/5">
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <Percent className="h-4 w-4 text-secondary" />
          Interest Rate
        </span>
        <span className="text-lg font-semibold">{interestRate || '15'}%</span>
      </div>
    </div>
  );
};
